import axios from '../../axios.js'

export default {
  addSelectedInvoices({ commit }, items) {
    commit("SET_PAYMENT_INVOICES", items);
  },
  addTransaction({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/transactions", item)
        .then((response) => {
          commit('ADD_TRANSACTION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
};
